/**
 * SiteDoc — the full editable shape of a site as held in the Yjs
 * document. This is also what the on-disk JSON files split into:
 *
 *   site.json         ← Site (id, name, description, theme) + edges
 *   pages/<id>.json   ← one Page per file
 *
 * The split lives on-disk to keep partial updates cheap (a page
 * rename only touches `pages/<id>.json`; a theme change only touches
 * `site.json`). In memory and over Yjs, it's a single object.
 *
 * The y-xyflow binding (S5 → T3.2) syncs `pages` and `edges` arrays
 * granularly via the Y.Map<id, NodeData> / Y.Map<id, EdgeData> shape.
 * `site` (id, name, description, theme) syncs as a single Y.Map under
 * a "site" key.
 */
import * as Schema from "effect/Schema";

import { Edge } from "./edge.js";
import { Page } from "./page.js";
import { Site } from "./site.js";

export const SiteDoc = Schema.Struct({
  site: Site,
  pages: Schema.Array(Page),
  edges: Schema.Array(Edge),
});
export type SiteDoc = Schema.Schema.Type<typeof SiteDoc>;
